import React from 'react';
import { ExternalLink, Users } from 'lucide-react';

const COMMUNITIES = [
    {
        title: 'Multi Seller Pro',
        description: 'Join our seller community for real time tips, and help from hundreds of expert sellers.',
        emoji: '📦',
        color: 'from-teal-500 to-blue-600',
        bg: 'bg-teal-50',
        border: 'border-teal-200',
        links: [
            {
                label: 'Join Discord',
                url: 'https://discord.gg/9HYtdtugDY',
                btnColor: 'from-indigo-500 to-indigo-700',
                icon: (
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z" /></svg>
                ),
            },
            {
                label: 'Join Facebook Group',
                url: 'https://www.facebook.com/groups/multisellerpro/',
                btnColor: 'from-blue-500 to-blue-700',
                icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                ),
            },
        ],
    },
    {
        title: 'Multi Influencer Pro',
        description: 'Connect with AIP influencers, share strategies, and grow your audience together.',
        emoji: '🎬',
        color: 'from-purple-500 to-pink-600',
        bg: 'bg-purple-50',
        border: 'border-purple-200',
        links: [
            {
                label: 'Join Discord',
                url: 'https://discord.gg/9HYtdtugDY',
                btnColor: 'from-indigo-500 to-indigo-700',
                icon: (
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z" /></svg>
                ),
            },
            {
                label: 'Join Facebook Group',
                url: 'https://www.facebook.com/groups/multiinfluencerpro',
                btnColor: 'from-blue-500 to-blue-700',
                icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                ),
            },
        ],
    },
];

const CommunitiesPage = ({ user }) => {
    return (
        <div className="max-w-3xl mx-auto py-12 px-6">

            <div className="mb-10">
                <div className="flex items-center gap-2 mb-2">
                    <Users size={22} className="text-teal-600" />
                    <h1 className="text-3xl font-bold text-gray-800">MultiSellerPro Communities</h1>
                </div>
                <p className="text-gray-500">Connect with thousands of sellers and influencers just like you.</p>
            </div>

            <div className="flex flex-col gap-6">
                {COMMUNITIES.map((c) => (
                    <div
                        key={c.title}
                        className={`bg-white rounded-2xl shadow-lg border ${c.border} overflow-hidden`}
                    >
                        {/* Top color bar */}
                        <div className={`h-2 bg-gradient-to-r ${c.color}`} />

                        <div className="p-6">
                            {/* Title row */}
                            <div className="flex items-center gap-3 mb-3">
                                <div className={`w-12 h-12 rounded-xl ${c.bg} flex items-center justify-center text-2xl flex-shrink-0`}>
                                    {c.emoji}
                                </div>
                                <div>
                                    <h2 className="text-xl font-bold text-gray-800">{c.title}</h2>
                                    <p className="text-gray-500 text-sm mt-0.5">{c.description}</p>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="grid grid-cols-2 gap-3 mt-4">
                                {c.links.map((link) => (
                                    <a
                                        key={link.label}
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`py-2.5 bg-gradient-to-r ${link.btnColor} text-white rounded-xl font-bold hover:opacity-90 transition shadow flex items-center justify-center gap-2 text-sm`}
                                    >
                                        {link.icon}
                                        {link.label}
                                        <ExternalLink size={14} />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <p className="text-center text-black text-xl mt-10">
                Questions? Reach out at <strong>contact@multisellerpro.com</strong>
            </p>

        </div>
    );
};

export default CommunitiesPage;